import { Filter } from './filters';

export class FiltersHelper {
  public static getCompanyIdsFromView(filters: Array<Filter>): Array<string> {
    const companyFilter = filters.find(filter => filter.company)?.company;

    if (!companyFilter) {
      throw new Error('Could not find any companyIds for view');
    }

    if (!companyFilter.in) {
      console.error('Possibly lost access to previously selected company in filter');
      return [];
    }

    return companyFilter.in;
  }
}
